@for (product of order.products; track trackByProductsFcn(i, product); let i = $index) {
	@if (product.additionalQuestions != null) {
		<div id="additional-questions-{{product.standard.name}}" class="product-additional-questions">
			<div class="product-header">
				<div style="display: flex;">
					<h6 class="standard-name">{{ 'common.iso-certification-sub-title' | translate: {standard: product.standard.name | standardName} }}</h6>
				</div>
				<a class="toggle-view-section" (click)="toggleVisibility(product)">
					{{ (isVisible(product) ? 'common.hide' : 'common.show') | translate }}
					<nb-icon icon="{{isVisible(product) ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'}}"></nb-icon>
				</a>
			</div>
			<div [ngClass]="{'hide-section': !isVisible(product)}">
				@if (copyable) {
					<copy-button [standard]="product.standard" [text]="getCopyButtonText()" [visible]="shouldShowCopyButtonFor(product, i)"
								 (copyButtonClicked)="copyAnswers$.emit(product)"></copy-button>
				}
				<audit-dates [order]="order" [product]="product" [clientLogged]="clientLogged"></audit-dates>
				@if (isTransfer(product)) {
					<transfer-details [order]="order" [product]="product"></transfer-details>
				}
				<product-additional-questions [order]="order" [product]="product" [textQuestions]="textQuestionsFor(product)"
											  [binaryQuestions]="binaryQuestionsFor(product)"></product-additional-questions>
			</div>
		</div>
	}
}
